import React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import {
  StyledEngineProvider,
  ThemeProvider,
} from '@lifeomic/chroma-react/styles';
import { theme } from '@lifeomic/phc-web-toolkit/src/theme/phc';
import App from './App';
import { IntlProvider } from 'react-intl';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import history from '../redux/util/history';
import { ConnectedRouter } from 'connected-react-router';
import { RootErrorBoundary } from '../util/errorReporting';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'whatwg-fetch'; // fetch polyfill.  Useful for cypress to mock XHR requests
import { OmnibarProvider } from '@lifeomic/phc-web-toolkit/src/components/Omnibar/OmnibarProvider';

const reactQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 10,
    },
  },
});

const Root = ({
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  store, // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  apolloClient,
}) => (
  <RootErrorBoundary>
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <IntlProvider locale="en" textComponent={React.Fragment}>
              <ConnectedRouter history={history}>
                <QueryClientProvider client={reactQueryClient}>
                  <OmnibarProvider>
                    <App />
                  </OmnibarProvider>
                </QueryClientProvider>
              </ConnectedRouter>
            </IntlProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </ApolloProvider>
    </Provider>
  </RootErrorBoundary>
);

export default Root;
